enum TaskDeadlineState {
    EXCEEDED = 'exceeded',
    APPROACHING = 'approaching',
}

export default TaskDeadlineState;
